/**
 * SEO 配置 - models (Türkçe)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Fizik Kurallarına Uygun AI Video Oluşturucu | WeryAI',
        description: 'Senkronize ses ve çoklu çekim anlatı tutarlılığı ile OpenAI Sora 2 kullanarak fiziksel olarak doğru, gerçekçi AI videoları oluşturun.',
        keywords: 'Sora 2, OpenAI Sora, video modeli, gerçekçi AI video, metinden videoya, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Sinematik AI Video Oluşturucu | WeryAI',
        description: 'Kling 2.5 Turbo, gelişmiş lens kontrolü, duygusal ifadeler ve akıcı hareket fiziği ile sinematik, yüksek kaliteli AI videoları oluşturur.',
        keywords: 'Kling 2.5 Turbo, Kling AI, sinematik AI video, lens kontrolü AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Gelişmiş Yapay Zeka Video Oluşturucu ve Düzenleyici | WeryAI',
        description: `Runway Gen-4, daha derin istem anlayışı ve akıllı düzenleme araçlarıyla gerçekçi, tutarlı yapay zeka videoları üretir. WeryAI'de ücretsiz deneyin.`,
        keywords: 'Runway Gen-4, Runway AI, yapay zeka video oluşturucu, metinden videoya, görüntüden videoya, yapay zeka video düzenleme, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Video Oluşturucu - Gelişmiş Video Üretimi | WeryAI',
        description: `WeryAI'da Hailuo AI ile gelişmiş AI videoları oluşturun. En yeni hareket kontrolü ve gerçekçi sahne oluşturma özellikleri.`,
        keywords: 'Hailuo AI, MiniMax, AI video oluşturucu, hareket kontrolü, gerçekçi video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance Yapay Zeka Video Üreticisi - Dans ve Hareket Oluşturma | WeryAI',
        description: 'Seedance Yapay Zeka Video Üreticisi - Dans ve Hareket Oluşturma on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro Yapay Zeka Görsel Oluşturma | WeryAI',
        description: 'Nano Banana Pro - Google Gemini 3.0 Pro Yapay Zeka Görsel Oluşturma on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash yüksek hızlı çizim | WeryAI',
        description: 'Google Nano Banana - Gemini 2.5 Flash yüksek hızlı çizim on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI Görsel Oluşturucu - En İyi Açık Kaynak Çizim Modeli | WeryAI',
        description: 'FLUX AI Görsel Oluşturucu - En İyi Açık Kaynak Çizim Modeli on WeryAI. Fast and high-quality results.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Profesyonel Yapay Zeka Çizim Geliştirme | WeryAI',
        description: 'FLUX.1 Kontext - Profesyonel Yapay Zeka Çizim Geliştirme on WeryAI. Fast and high-quality results.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Google Gelişmiş Metinden Görsele Difüzyon Modeli | WeryAI',
        description: 'Google Imagen 4 - Google Gelişmiş Metinden Görsele Difüzyon Modeli on WeryAI. Fast and high-quality results.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Alibaba Açık Kaynak Metin Oluşturma Modeli | WeryAI',
        description: 'Qwen Image - Alibaba Açık Kaynak Metin Oluşturma Modeli on WeryAI. Fast and high-quality results.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Görsel Oluşturma - Alibaba Yüksek Sadakatli Görsel Modeli | WeryAI',
        description: 'Wan 2.5 Görsel Oluşturma - Alibaba Yüksek Sadakatli Görsel Modeli on WeryAI. Fast and high-quality results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDance Toplu 4K Çizim Modeli | WeryAI',
        description: 'Seedream 4.0 - ByteDance Toplu 4K Çizim Modeli on WeryAI. Fast and high-quality results.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDance Hepsi Bir Arada Yapay Zeka Görsel Oluşturma Modeli | WeryAI',
        description: 'Dreamina 4.0 - ByteDance Hepsi Bir Arada Yapay Zeka Görsel Oluşturma Modeli on WeryAI. Fast and high-quality results.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDance Amiral Gemisi Yapay Zeka Görüntü Oluşturma Modeli | WeryAI',
        description: 'Seedream 4.5, ByteDance\'ın en yeni amiral gemisi yapay zeka görüntü modelidir; hassas tipografi işleme ve 4K ultra HD çıktı ile çoklu görüntü birleştirmeye odaklanır. WeryAI\'de ücretsiz deneyin.',
        keywords: 'Seedream 4.5, yapay zeka görüntü oluşturma, tipografi işleme, görüntü birleştirme, ByteDance, 4K kalite, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - En İyi Sanatsal Estetik Yapay Zeka Çizimi | WeryAI',
        description: 'Midjourney - En İyi Sanatsal Estetik Yapay Zeka Çizimi on WeryAI. Fast and high-quality results.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Yapay Zeka Video Oluşturucu - Sinematik Videolar Oluşturun | WeryAI',
        description: 'WeryAI\'de Runway Gen-4.5 ile muhteşem videolar oluşturun. Hassas fizik simülasyonu ve zamansal tutarlılık için hibrit otoregresif-difüzyon mimarisi.',
        keywords: 'Runway Gen-4.5, yapay zeka video oluşturucu, sinematik yapay zeka videosu, fizik simülasyonu, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Yapay Zeka Video Oluşturucu - Yüksek Kalite Video Oluşturma | WeryAI',
        description: 'WeryAI\'de Kling 2.6 Pro ile yüksek kaliteli videolar üretin. Yerel görsel-işitsel üretim, sinematik 1080p kalite, mükemmel prompt uyumu.',
        keywords: 'Kling 2.6 Pro, yapay zeka video oluşturucu, yüksek kalite yapay zeka videosu, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Oluşturucu - Hassas kamera kontrolü ve kare rehberliği | WeryAI',
        description: 'WeryAI\'de Dreamina 3.0 (Jimeng 3.0) ile sinematik yapay zeka videoları üretin. Hassas başlangıç/bitiş kare kontrolü, profesyonel kamera hareketleri ve 1080p yüksek dinamik video üretimi.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, yapay zeka video oluşturucu, kamera kontrolü, başlangıç bitiş karesi, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Yapay Zeka Video Oluşturucu - Yaratıcı Video Üretimi | WeryAI',
        description: 'WeryAI\'de Kling O1 yapay zeka video oluşturucu ile yaratıcılığınızı serbest bırakın. Hayal gücü dolu ve benzersiz video içeriği üretmek için mükemmel.',
        keywords: 'Kling O1, yapay zeka video oluşturucu, yaratıcı yapay zeka videosu, Kling AI, WeryAI',
    },
}
